import { Link, useNavigate } from "react-router-dom";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import { DropdownItem } from "../Shared/DropdownItem";
import { ReactComponent as LogoutIcon } from "../../assets/svg/logout.svg";
import { Dropdown } from "../Shared/Dropdown";
import { getCandidateProfilePictureURL, getRecruiterProfilePictureURL } from "../../helpers/Common";
import { LoggedCandidate } from "../../models/LoggedCandidate";
import { postCandidateLogout } from "../../services/CandidateService";
import { postRecruiterLogout } from "../../services/RecruiterService";
import { useContext, useState } from "react";
import { StyleContext } from '../../providers/StyleContextProvider';

interface Props {
    candidate?: LoggedCandidate | null;
    recruiter?: LoggedRecruiter | null;
    isRecruiterHeader?: boolean;
}

export const ProfileEntrance: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const candidateProfilePictureURL = props.candidate && getCandidateProfilePictureURL(props.candidate.candidateId, props.candidate.token);
    const recruiterProfilePictureURL = props.recruiter && getRecruiterProfilePictureURL(props.recruiter.recruiterId);
    const styleContext = useContext(StyleContext);
    const [styles] = useState<any>(styleContext.getComponentStyle("profileEntrance")); 

    const candidateLogout = () => {
        localStorage.removeItem("candidate");
        localStorage.removeItem("savedJobIds");
        localStorage.removeItem("token");
        localStorage.removeItem("verificationShown");
        postCandidateLogout(props.candidate!.candidateId);
        navigate('/candidates/login');
    }

    const recruiterLogout = () => {
        localStorage.removeItem("recruiter");
        localStorage.removeItem("token");
        postRecruiterLogout(props.recruiter!.recruiterId, props.recruiter!.token);
        navigate('/recruiter/account/login');
    }

    const candidateProfileItems: any[] = [
        { item: 
            <Link to={'/candidate/updateprofile'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"My Profile"}</DropdownItem>
            </Link>              
        },
        { item: 
            <Link to={'/candidate/myapplications'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Status of Applications"}</DropdownItem>
            </Link>
        },
        { item: 
            <Link to={'/candidate/managesavedjobs'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Saved Jobs"}</DropdownItem>
            </Link>
        },
        { item: 
            <Link to={'/candidateSettings/password'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Settings"}</DropdownItem>
            </Link>
        },
        { item: 
            <div style={{...styles.dropdownLabel, ...styles.logoutDropdownLabel}}>
                <DropdownItem onClick={candidateLogout} styles={styles.logoutDropdownItem}>
                    {"Logout"}
                    <LogoutIcon style={styles.logoutIcon} />
                </DropdownItem>                
            </div>
        }
    ]

    const recruiterProfileItems: any[] = [
        { item: 
            <Link to={'/recruiter/vacancy'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Dashboard"}</DropdownItem>
            </Link>              
        },
        { item: 
            <Link to={'/recruiter/settings/account'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Recruiter Settings"}</DropdownItem>
            </Link>              
        },
        { item: 
            <Link to={'/recruiter/settings/organization'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Organization Settings"}</DropdownItem>
            </Link> 
        },
        { item: 
            <Link to={'/recruiter/settings/integration'} style={styles.dropdownLabel}>
                <DropdownItem styles={styles.dropdownItem}>{"Integrations"}</DropdownItem>
            </Link> 
        },
        ...(props?.recruiter?.isOrganizationAdmin ? [
            { item: 
                <Link to={'/recruiter/users'} style={styles.dropdownLabel}>
                    <DropdownItem styles={styles.dropdownItem}>{"Users"}</DropdownItem>
                </Link> 
            }
        ]: []),
        { item: 
            <div style={{...styles.dropdownLabel, ...styles.logoutDropdownLabel}}>
                <DropdownItem onClick={recruiterLogout} styles={styles.logoutDropdownItem}>
                    {"Logout"}<LogoutIcon style={styles.logoutIcon} />
                </DropdownItem>                
            </div>
        }
    ]

    return (
        <div style={styles}>
            {props.candidate && <div style={styles.userWrapper}>
                <Dropdown styles={styles.userDropdown} items={candidateProfileItems}>
                    {candidateProfilePictureURL && 
                    <img 
                        src={candidateProfilePictureURL} 
                        style={{...styles.userAvatar, ...styles.candidateUserAvatar}}
                    />}
                    <span style={styles.userName}>{props.candidate.forename}</span>
                </Dropdown>
            </div>}
            {props.recruiter && <div style={styles.userWrapper}>
                <Dropdown 
                    styles={{
                        ...styles.userDropdown,
                        labelIcon: {...styles.userDropdown.labelIcon, ...(!props.isRecruiterHeader && styles.recruiterLabelIcon)}
                    }} 
                    items={recruiterProfileItems}
                >
                    {recruiterProfilePictureURL && 
                    <img 
                        src={recruiterProfilePictureURL} 
                        style={{...styles.userAvatar, ...(props.isRecruiterHeader ? styles.candidateUserAvatar : styles.recruiterUserAvatar)}}
                    />}
                    <span style={styles.userName}>{props.recruiter.forename}</span>
                </Dropdown>
            </div>}                    
        </div>
    );
}